export enum SponsorDealStatusEnum {
  ANALYSIS = 'Analysis',
  MARKETING = 'Marketing',
  CLOSED = 'Closed',
  LEGALS = 'Legals',
  ARCHIVED = 'Archived',
}
